const ingredientsData = {
    crust: [
        { type: 'thin', price: 0 },
        { type: 'double-dough', price: 1 },
        { type: 'deep-dish', price: 2 },
    ],
    sauce: [
        { type: 'tomato', price: 0 },
        { type: 'white', price: 1 },
        { type: 'evoo', price: 1 },
    ],
    toppings: [
        { type: 'pepperoni', price: 0.5 },
        { type: 'sausage', price: 0.5 },
        { type: 'bacon', price: 0.5 },
        { type: 'ham', price: 0.5 },
        { type: 'anchovies', price: 0.5 },
        { type: 'mushrooms', price: 0.5 },
        { type: 'black olives', price: 0.5 },
        { type: 'green peppers', price: 0.5 },
        { type: 'red onions', price: 0.5 },
        { type: 'pineapple', price: 0.5 },
        { type: 'sliced tomatoes', price: 0.5 },
    ]
}

export default ingredientsData;